/**
 * Sekcja „Podpowiedzi pojazdów” jako cel przycisku „Pokaż rekomendowane
 * pojazdy” z alertu o przeplanowaniu (przegląd karty zlecenia przed
 * prezentacją 02.10.2026).
 *
 * Alert i sekcja to osobne komponenty bez wspólnego stanu, więc łączy je
 * strona: sekcja ma stałe `id`, a jej przycisk „Podpowiedz auta” — znacznik,
 * dopóki podpowiedzi nie są policzone. Alert przewija do sekcji i klika ten
 * przycisk tak, jak zrobiłby to planista. Policzonych podpowiedzi nie liczy
 * od nowa — tylko przewija.
 */

/** `id` sekcji podpowiedzi na karcie zlecenia (owija ją `UserOfferShow.tsx`). */
export const VEHICLE_SUGGESTIONS_ANCHOR_ID = 'vehicle-suggestions';

/**
 * Przycisk „Podpowiedz auta”, póki podpowiedzi nie są policzone — atrybut
 * `data-suggest-start` w `VehicleSuggestions.tsx`.
 */
export const SUGGEST_START_SELECTOR = 'button[data-suggest-start]';

/**
 * Przewija do sekcji podpowiedzi i — gdy nie są jeszcze policzone —
 * uruchamia je. `false`, gdy sekcji na karcie nie ma (konto bez planowania
 * FTL nie widzi ani sekcji, ani alertu).
 */
export function showVehicleSuggestions(): boolean {
  const section = document.getElementById(VEHICLE_SUGGESTIONS_ANCHOR_ID);
  if (!section) return false;
  section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  const start = section.querySelector<HTMLButtonElement>(SUGGEST_START_SELECTOR);
  if (start && !start.disabled) start.click();
  return true;
}
